import { createGlobalState } from '@vueuse/core';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { GlobalProxy } from '@patsnap/hiro-event-proxy';
import { computed, ref } from 'vue';
import { HiroEntryService } from '@patsnap/hiro-event-proxy';
import _ from 'lodash';

export const useHiro = createGlobalState(() => {
    const hiroIsLoaded = ref(false);
    const enableReadImage = ref(false);

    const globalProxy = injectService<GlobalProxy>(GlobalProxy);
    const hiroEntryService = injectService<HiroEntryService>(HiroEntryService);

    globalProxy.eventProxy.on('loaded', () => {
        hiroIsLoaded.value = true;
    });

    // 获取 Hiro 配置并判断是否开启了 enable_read_image
    hiroEntryService.getHiroBasicConfig().then(config => {
        enableReadImage.value = !!_.get(config.agentConfigs, 'chat.enable_read_image', false);
    });

    return {
        hiroIsLoaded,
        showReadImageButton: computed(() => hiroIsLoaded.value && enableReadImage.value),
    };
});